export default "__VITE_ASSET__CSP1dnNA__"